import { Component, Input, OnInit } from '@angular/core';
import { Surcharge } from '../../models/contract.interface';

@Component({
  selector: 'app-surcharges-list',
  templateUrl: './surcharges-list.component.html',
  styleUrls: ['./surcharges-list.component.scss']
})
export class SurchargesListComponent implements OnInit {
  @Input() surcharges: Surcharge[] = [];
  @Input() isLoading? = false;

  tableName: string ='surcharges'
  constructor() { }

  ngOnInit(): void {
  }
  

}
